import React from 'react';
import FilteredThread from '../components/FilteredThread';

const Pictures = () => {
    return (
        <FilteredThread type="image" />
    );
};

export default Pictures;